<template>
    <div class="container mt-3 pt-5 partners">
        <div class="row">
            <div class="col-lg-12 mx-md-auto text-center">
                <h2 class="font-weight-normal text-9 text-uppercase mb-3">Our Partners</h2>
                <div v-if="ready==false" class="loader">
                    <div class="container">
                        <div class="row">
                            <div class="col-sm-1 mx-md-auto mt-2 text-center">
                                <spring-spinner
                                :animation-duration="5000"
                                :size="60"
                                color="#124191"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="items" v-else>
                    <a :href="p.link" target="_blank" v-for="p in partners" :key="p.id"><img :src="p.full_image_url" style="" :alt="p.name" /></a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import { SpringSpinner  } from 'epic-spinners'

export default {
    name: 'Partners',
    components: {
        SpringSpinner  
    },
    data(){
        return{
            partners: '',
            files: '',
            base: false,
            ready: false,
        }
    },
    methods: {
        getView(){
            this.partners.forEach(p => {
                let v = this.files.find(v => v.id == p.logo);
                p.full_image_url = v.data.full_url;
            })
            this.ready = true;             
        },
        getPartners(url){
            return axios.get(url)
                .then(response => {
                    this.partners = response.data.data;
                })
                .catch(error => {
                    console.log(error)
                })
        },
        getImages(url){
            return axios.get(url)
                .then(response => {
                    this.files = response.data.data;
                })
                .catch(error => {
                    console.log(error)
                })
                .finally(() => this.base = true)  
        }
    },
    watch: {
        base: function(val) {
            setTimeout(()=>{
                this.getView();    
            },1000); 
        }
    },
    created(){
        this.getPartners(process.env.VUE_APP_BASE_URL+'/codedive/items/partners');
        this.getImages(process.env.VUE_APP_BASE_URL+'/codedive/files');
    }
}
</script>

<style lang="scss">
    .partners{
        width: 100%;
        .items{
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-wrap: wrap;
            img{
                margin: 2rem 0.5rem;
                max-width: 200px;
                max-height: 80px;
            }
        }
    }
</style>